import React, { Fragment } from "react";

export default (
  <>
    <rect width="24" height="6" rx="2" />
    <rect y="9" width="24" height="6" rx="2" />
    <rect y="18" width="24" height="6" rx="2" />
  </>
);
